// reducers/metaReducer.js
// classes, sections, subjects — dropdowns కోసం
export const metaReducer = (
  state = { classes: [], sections: [], subjects: [], academicYears: [] },
  action,
) => {
  switch (action.type) {
    case "CLASSES_REQUEST":
    case "SECTIONS_REQUEST":
    case "SUBJECTS_REQUEST":
      return { ...state, metaLoading: true };
    case "GET_CLASSES_SUCCESS":
      return { ...state, metaLoading: false, classes: action.payload };
    case "GET_SECTIONS_SUCCESS":
      return { ...state, metaLoading: false, sections: action.payload };
    case "GET_SUBJECTS_SUCCESS":
      return { ...state, metaLoading: false, subjects: action.payload };
    case "GET_ACADEMIC_YEARS_SUCCESS":
      return { ...state, academicYears: action.payload };
    case "CLASSES_FAIL":
    case "SECTIONS_FAIL":
    case "SUBJECTS_FAIL":
      return { ...state, metaLoading: false };
    default:
      return state;
  }
};
